// 年表數據庫。
export const state = {
  reportRatioYear: [
    {
      company_name: "",
      stock_symbol: 0,
      year_liquidities: [
        {
          accounts_and_bills_payable: "",
          accounts_and_bills_receivable: "",
          bank_loan_non_current: "",
          cash_and_cash_equivalents: "",
          commercial_paper_payable_acceptance_bill: "",
          corporate_bond: "",
          current_assets: "",
          current_liabilities: "",
          current_tax_liabilities: "",
          financial_liabilities_non_current: "",
          inventories: "",
          loan_to_other_S_T: "",
          long_term_investments: "",
          long_term_liabilities_due_within_one_year: "",
          non_current_assets: "",
          non_current_liabilities: "",
          other_current_assets: "",
          other_current_liabilities: "",
          other_financial_liabilities_current: "",
          other_long_term_debt_payable_non_current: "",
          other_non_current_assets: "",
          other_payables: "",
          other_receivables: "",
          prepaid_expenses_and_repayments: "",
          property_plant_and_equipment: "",
          short_term_debt: "",
          short_term_financial_liability_current: "",
          short_term_investment_financial_assets_current: "",
          total_assets: "",
          total_goodwill_and_intangible_assets: "",
          total_intangible_assets: "",
          total_liabilities: "",
          total_other_L_T_liab: "",
          year: ""
        }
      ],
      year_return_on_investments: [
        {
          EBOA: "",
          EBOE: "",
          EBOIC: "",
          ROA: "",
          ROE: "",
          ROIC: "",
          gross_profit_ratio: "",
          net_profit_margin_ratio: "",
          operating_expense_ratio: "",
          year: ""
        }
      ],
      year_per_share_ratios: [
        {
          EBIDTA_per_share: "",
          cash_reinvestment_ratio: "",
          dividend_redistribution_ratio: "",
          year: "",
          EPS: ""
        }
      ],
      year_operating_performances: [
        {
          days_of_accounts_payable_turnover: "",
          days_of_cash_receivable: "",
          days_of_cash_turnover: "",
          days_of_operation_turnover: "",
          days_of_sales: "",
          year: ""
        }
      ]
    }
  ],
  errorMessage: ""
};
